import React from "react"

import diesel from "../../images/diesel.png"

import "./home.scss"

const Home = () => (
  <section className="section home">
    <h1 className="sectionTitle home">STOP TOXIC HOUSING</h1>
    <div className="map">
      <div className="imageBlock diesel">
        <div className="homeCaptionWrapper">
          <h3 className="homeImageCaption">Diesel-Particulate Pollution in Pasadena (CAL-EPA)</h3>
        </div>
        <div className="imageWrapper">
          <img className="homeImage" src={diesel} alt="diesel particulate pollution in pasadena"/>
        </div>
      </div>
    </div>
  </section>
)

export default Home
